import React, { Component } from 'react';
import { connect } from 'react-redux';
import Axios from 'axios';

import Header from '@/components/Header';
import Newsletter from '../../components/_common/Newsletter';
import MetaDetail from '../../components/_common/MetaDetail';
import tracking from '../../utils/tracking';
import menuHero  from './images/small-plates-hero.jpg';
import './menu.scss';

class MenuPage extends Component {
	constructor(props) {
		super(props);
		this.getMenu();
		this.getNewsletter();
	}

	async getMenu() {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';

		await Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/Menu.json?v=${Math.random()}`)
			.then(response => {
				this.setMenuData(response);
			});
	}

	setMenuData(response) {
		let title;
		let subhead;
		let item;
		let foodItems = [];

		for (let field of response.data.contents[0].fields) {
			if (field.id === 'menutitle') {
				this.setState({ title: field.value || 'Food Menu' });
				continue;
			}
			else if (field.id === 'menusubhead') {
				this.setState({ subhead: field.value });
				continue;
			}
			else if (field.id === 'fooditem') {
				this.fetchFoodItems(field.fields).then(response => { this.consolidateItems(response); });
			}
			continue;
		}
	}

	consolidateItems(stuff) {
		return Promise.all(stuff)
			.then((vals) => vals)
			.then((lot) => {
				this.setState({ items: lot });
			});
	}

	async getFoodItemContent(url) {
		return Axios.get(url);
	}

	async fetchFoodItems(foodItemList) {
		let that = this;

		let foodItemUrls = foodItemList.map((item) => item.id === 'fooditem' && item.value);

		let foodContent = foodItemUrls.map(async (url) => {
			let entry = await this.getFoodItemContent(url);
			return entry.data.contents[0].fields;
		});

		return foodContent;
	}

	async getNewsletter() {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';

		await Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/NEWSLETTER OVERLAY.json?v=${Math.random()}`)
			.then(response => {
				this.setState({ newsletterData: response.data.contents });
			});
	}

	componentDidMount() {
		tracking.pageView('/menu');
	}

	getItemColor(index) {
		if (index % 3 === 0) {
			return 'green';
		}
		if ((index + 1) % 3 === 0) {
			return 'red';
		}
		return 'blue';
	}

	Item = function (jsonItem) {
		const item = {};
		for (let itemField of jsonItem[0].fields) {
			if (itemField.id === 'itemname') {
				item.name = itemField.value;
				continue;
			}
			else if (itemField.id === 'itemdescription') {
				item.desc = itemField.value;
				// item.desc = (dangerouslySetInnerHTML={__html: itemField.value})
				continue;
			}
			else if (itemField.id === 'nutritioninfo') {
				item.nutrition = itemField.value;
				continue;
			}
			else if (itemField.id === 'price') {
				item.price = itemField.value;
				continue;
			}
			else if (itemField.id === 'image') {
				item.img = itemField.imgURL;
				item.imgAlt = itemField.alternateText;
				continue;
			}
		}
		return item;
	}

	render() {
		const title = this.state.title;
		const subhead = this.state.subhead;
		const menuItems = this.state.items;
		let items;
		const newsletter = this.state.newsletterData;
		let newsletterContent = [];
		let signUpFormData = {};
		let signUpFormContents = {};

		const meta = {
			title: 'The Food Menu',
			description: 'Open Gate Brewery Menu, Food and drink experience Dublin, Guinness Bar/Restaurant Dublin, Food Dublin 8',
			canonical: window.location.href
		};

		if (menuItems) {
			items = menuItems.map(item => this.Item(item));
		}

		if (newsletter != undefined) {
			for (let i = 0; i < newsletter.length; i++) {
				let fieldsObj = {};
				let contentKey = '';
				for (let field of newsletter[i].fields) {
					if (field.id === 'module') {
						switch (field.value) {
							case ('Sign up - overlay screen 1'):
								contentKey = 'Screen1';
								break;
							case ('Form field 1 - YOUR EMAIL'):
								contentKey = 'Field1';
								break;
							case ('Sign up - overlay screen 2'):
								contentKey = 'Screen2';
								break;
							case ('Sign up - already subscribed'):
								contentKey = 'Screen3';
								break;
							default:
								console.log('Unknown Key');
								break;
						}
						continue;
					}
					else if (field.id === 'modules-details') {
						for (let newsField of field.fields) {
							let fieldKey = newsField.title;
							let fieldVal = newsField;
							fieldsObj[fieldKey] = fieldVal;
						}
						continue;
					}
				}
				if (contentKey === 'Screen1') {
					newsletterContent.push(fieldsObj);
				}

				signUpFormContents[contentKey] = [];
				signUpFormContents[contentKey].push(fieldsObj);
			}

			signUpFormData.contents = signUpFormContents;
		}

		if (!signUpFormData) return null;
		signUpFormData.fetchedData = signUpFormData.built = true;

		return (
			<div className="menu" >
				<Header />
				<div role="main" aria-label="Menu Page" className="menu-page">
					<MetaDetail meta={meta} />
					<div className={'hero hero--active'}>
						<div className={'feature feature--active'}>
							<div className={'hero__container'}>
								<img className={'hero__background'} src={menuHero} alt="Check out Open Gate Brewery's extensive food and beer menu. Join us in D8, Dublin for a food and drink experience like no other." />
								<div className={'hero__heading-container'}>
									<div className={'hero__text-container'}>
										<h1 className={'hero__title'}>{title}</h1>
										<p className={'hero__subhead'}>{subhead}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					{items && items.map((item, i) => {
						let color = `menu-item__bg--${this.getItemColor(i)}`;
						return (
							<div className={'feature feature--active menu__container'}>
								<div className={`menu-item__wrap ${i % 2 === 0 ? 'image-right' : 'image-left'} ${color}`}>
									<div className={'menu-item__text-container'}>
										<h2 className={'menu-item__name'}>{item.name}</h2>
										<div className={'menu-item__separator'} />
										<div className={'menu-item__desc'} dangerouslySetInnerHTML={{ __html: item.desc }} />
										{item.nutrition &&
											<div className={'menu-item__nutrition'}>
												{item.nutrition.split('*').map((entry, i) => {
													if (entry !== '') {
														return (<span className={'nutrition-item'}>
															<span className={'nutrition-item__label'}>{entry.split(':')[0].trim()}</span>&nbsp;
															{i < item.nutrition.split('*').length - 1
																? <span className={'nutrition-item__qty'}>{`${(entry.split(':')[1]).trim()},`} </span>
																: <span className={'nutrition-item__qty'}>{entry.split(':')[1].trim()}</span>
															}
														</span>);
													}
												})}
											</div>
										}
										<div className={'menu-item__separator'} />
										{item.price &&
											<h3 aria-hidden="true" className={'menu-item__price'}>{item.price}</h3>
										}
									</div>
									{/* <div className={'menu-item__image-container'} style={`background-image: url('${item.img}'); background-position: center; background-repeat: no-repeat; background-size: cover`} /> */}
								</div>
							</div>

						);
					})
					}
					{
						newsletterContent.length && signUpFormData &&
						<Newsletter
							content={newsletterContent[0]}
							formData={signUpFormData}
							routeProps={this.props.routeProps}
						/>
					}
				</div>
			</div >
		);
	}
}

export default MenuPage;



// WEBPACK FOOTER //
// ./src/pages/menu/index.js